<template>
  <section
    ref="interactionsSection"
    class="external-interactions-section"
    :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none', '--delayedOpacity-panelEnterDelayInSeconds': `${panelEnterDelayInSeconds}s` }">
    <Header ref="header" :openChannelId="channelId" v-if="!activityData.property.hideHeader" />
    <div class="interactions-hero" v-if="activityData.images && activityData.images.poster">
      <img class="interactions-hero-image" :src="activityData.images.poster" />
    </div>
    <!-- POSTER -->
    <img class="poster" ref="poster" :src="activityData.images.curtain" alt :style="[{ zIndex: '0' }]" v-if="activityData.images.curtain && !(showQA && activityData.property.interactivities.qa) && !interactionsOnStatus.length" />

    <div class="foyerCategory-title" v-html="title" v-if="title"></div>
    <!-- <div class="interactions-title" v-html="activityData.description_short"></div> -->
    <div class="page-container">
      <div class="interactions-container" v-if="interactionsOnStatus.length">
        <div v-for="(item, k) in allLists" :key="k + item.interactivity_id">
          <Quiz
            :config="activityData.property.interactivities.quiz.config"
            :ref="item.interactivity_id"
            :interacted="item.interacted"
            :scored="parseFloat(item.interacted_scored)"
            :correct="item.interacted_correct ? item.interacted_correct : [[]]"
            :resultsTitle="activityData.property.interactivities.quiz.config.quizResultsTitle"
            :typeShowResults="item.raw_data.type.showResults"
            :isCategory="item.raw_data.type.category"
            :categories="item.raw_data.type.categories"
            :categoryOverride="activityData.property.interactivities.quiz.config.categoryOverride"
            :localized="item.raw_data.localized"
            @finished="finishQuiz"
            v-if="item.reference_type === 'quiz' && item.raw_data.type" />
          <Essay
            :config="activityData.property.interactivities.answer.config"
            :ref="item.interactivity_id"
            :interacted="item.interacted"
            :scored="parseFloat(item.interacted_scored)"
            :correct="item.interacted_correct ? item.interacted_correct : [[]]"
            :resultsTitle="activityData.property.interactivities.answer.config.essayResultsTitle"
            :typeShowResults="item.raw_data.type.showResults"
            :isCategory="item.raw_data.type.category"
            :categories="item.raw_data.type.categories"
            :categoryOverride="activityData.property.interactivities.answer.config.categoryOverride"
            @finished="finishEssay"
            v-if="item.reference_type === 'answer'" />
          <Poll
            :config="activityData.property.interactivities.poll.config"
            :ref="item.interactivity_id"
            :interacted="parseInt(item.interacted)"
            :answers="item.raw_data.answers"
            :typeObject="item.raw_data.type"
            :typeShowResults="item.raw_data.type.showResults"
            :localized="item.raw_data.localized"
            @finished="finishPoll"
            v-if="item.reference_type === 'poll'" />
          <WordCloud
            :config="activityData.property.interactivities.quiz.config"
            :ref="item.raw_data.wordcloud_id"
            :data="item"
            :typeShowResults="item.raw_data.type.showResults"
            :sendText="activityData.property.interactivities.wordcloud.config.sendBtnText ? activityData.property.interactivities.wordcloud.config.sendBtnText : 'ENVIAR'"
            :postSendText="activityData.property.interactivities.wordcloud.config.postSendText ? activityData.property.interactivities.wordcloud.config.postSendText : 'Obrigado! Nossa nuvem de palavras está sendo criada!'"
            v-if="item.reference_type === 'wordcloud'" />
        </div>

        <!-- allFinishedModalPanel -->
        <div class="interactions-all-finished-modal" v-if="hasFinishedEverything && activityData.property.allFinishMessage">
          <div class="interactions-all-finished-modal-content">
            <img src="../assets/svg/ok.svg" />
            <h3 v-html="activityData.property.allFinishMessage ? activityData.property.allFinishMessage : 'Você finalizou todas as atividades. Obrigado por participar!'"></h3>
          </div>
        </div>

        <!-- showNextRouteBtn -->
        <div class="interactions-submit-container" v-if="activityData.property.showNextRouteBtn">
          <button class="interactions-submit-button" :class="{ disabled: !activityData.property.nextRouteBtnEnableAllways && !hasFinishedEverything }" @click="submitAndContinue">
            {{ activityData.property.nextRouteBtnText ? activityData.property.nextRouteBtnText : 'Continuar' }}
          </button>
        </div>
      </div>
      <Sidebox ref="sidebox" style="height: 60vh; width: 100%; max-width: 400px" :showQA="showQA" :activityData="activityData" v-if="showChat || showQA" />
    </div>

    <transition appear name="delayed-opacity" mode="out-in" v-if="showEndingPanel && hasFinishedAllQuiz">
      <div class="interaction-ending-panel" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }" @click="handleEndingPanelClick">
        <div class="image-container">
          <img :src="activityData.images.curtain" v-if="activityData.images.curtain" />
        </div>
      </div>
    </transition>
    <div class="footer-wrapper">
      <Footer />
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import Sidebox from '@/components/chat_qa_box/Sidebox.vue';
import Poll from '@/components/external_interactions/ExternalPoll.vue';
import WordCloud from '@/components/external_interactions/ExternalWordcloud.vue';
import Quiz from '@/components/external_interactions/ExternalQuiz.vue';
import Essay from '@/components/external_interactions/ExternalEssay.vue';

import api from '@/services/api';

export default {
  name: 'Interactions',
  components: {
    Header,
    Footer,
    Poll,
    WordCloud,
    Quiz,
    Essay,
    Sidebox,
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },

  data() {
    return {
      activityData: {
        activity: '',
        images: {},
        speaker: [],
        interactivities: {
          chat: false,
          qa: false,
          quiz: false,
          poll: false,
          wordcloud: false,
        },
        property: {
          showBar: false,
          srcVideo: '',
          meetlink: '',
          languagesVideo: [],
          fullMeet: { closable: false, url: '', img: '' },
          interactivities: { quiz: { config: { quizTitle: 'QUIZ', quizResultsTitle: 'Você acertou' } }, poll: { config: { pollTitle: 'ENQUETE', pollResultsTitle: 'RESULTADO' } } },
          //chatGraphQL: false,
        },
      },
      channelId: '',
      pinnedChatMessages: [],
      countMsg: 0,
      wsClient: null,
      subscriptionGraphQL: null,
      showEndingPanel: false,
      showChat: false,
      showQA: false,
      showPoll: false,
      showQuiz: false,
      pollData: null,
      title: '',
      showWordcloud: false,
      wordcloudData: null,
      interactionsOnStatus: [],
      loadingInterval: null,
      qnaPollingInterval: null,
      timerId: null,
      idleCounter: 0,
      idleTimeoutInSeconds: 90,
      enableIdleTimeout: false,
      panelEnterDelayInSeconds: 15,
      isMobile: false,
      question: '',
      userName: '',
      userCity: '',
      qnaConfig: null,
      sendQuesionTimeout: null,
      autoRedirectTimer: null,
    };
  },
  computed: {
    allLists() {
      return [...this.quizOnStatus, ...this.pollOnStatus, ...this.essayOnStatus, ...this.wordcloudOnStatus].sort((a, b) => a.raw_data.order - b.raw_data.order);
    },
    quizOnStatus() {
      let filtered = this.interactionsOnStatus.filter((i) => i.reference_type == 'quiz');
      let sorted = filtered.sort((a, b) => {
        return a.order - b.order;
      });
      let mapped = sorted.map((m) => {
        // console.log('quizOnStatus', { m });
        if (typeof m.interacted == 'string' && m.interacted.startsWith('[')) {
          try {
            m.interacted = JSON.parse(m.interacted);
            m.interacted = m.interacted.map((c) => JSON.parse(c));
          } catch (error) {}
        }

        if (typeof m.interacted_correct == 'string' && m.interacted_correct.startsWith('[')) {
          try {
            m.interacted_correct = JSON.parse(m.interacted_correct);
            // m.interacted_correct = m.interacted_correct.map(c => JSON.parse(c));
          } catch (error) {}
        }
        if (typeof m.raw_data == 'string' && m.raw_data.startsWith('{')) m.raw_data = JSON.parse(m.raw_data);
        if (typeof m.raw_data.type == 'string' && m.raw_data.type.startsWith('{')) m.raw_data.type = JSON.parse(m.raw_data.type);
        return m;
      });
      return mapped;
    },
    essayOnStatus() {
      let filtered = this.interactionsOnStatus.filter((i) => i.reference_type == 'answer');
      let sorted = filtered.sort((a, b) => {
        return a.order - b.order;
      });
      let mapped = sorted.map((m) => {
        if (typeof m.interacted == 'string' && m.interacted.startsWith('[')) {
          m.interacted = JSON.parse(m.interacted);
          m.interacted = m.interacted.map((c) => JSON.parse(c));
          // console.log('quizOnStatus m.interacted', { m });
        }

        if (typeof m.interacted_correct == 'string' && m.interacted_correct.startsWith('[')) {
          try {
            m.interacted_correct = JSON.parse(m.interacted_correct);
            // m.interacted_correct = m.interacted_correct.map(c => JSON.parse(c));
          } catch (error) {}
        }
        if (typeof m.raw_data == 'string' && m.raw_data.startsWith('{')) m.raw_data = JSON.parse(m.raw_data);
        if (typeof m.raw_data.type == 'string' && m.raw_data.type.startsWith('{')) m.raw_data.type = JSON.parse(m.raw_data.type);
        return m;
      });
      return mapped;
    },
    pollOnStatus() {
      let filtered = this.interactionsOnStatus.filter((i) => i.reference_type == 'poll');
      let sorted = filtered.sort((a, b) => a.order.localeCompare(b.order));
      let mapped = sorted.map((m) => {
        if (typeof m.raw_data == 'string' && m.raw_data.startsWith('{')) m.raw_data = JSON.parse(m.raw_data);
        if (typeof m.raw_data.type == 'string' && m.raw_data.type.startsWith('{')) m.raw_data.type = JSON.parse(m.raw_data.type);
        return m;
      });
      return mapped;
    },
    wordcloudOnStatus() {
      let filtered = this.interactionsOnStatus.filter((i) => i.reference_type == 'wordcloud');
      let sorted = filtered.sort((a, b) => a.order.localeCompare(b.order));
      let mapped = sorted.map((m) => {
        if (typeof m.raw_data == 'string' && m.raw_data.startsWith('{')) m.raw_data = JSON.parse(m.raw_data);
        if (typeof m.raw_data.type == 'string' && m.raw_data.type.startsWith('{')) m.raw_data.type = JSON.parse(m.raw_data.type);
        return m;
      });
      return mapped;
    },
    hasFinishedAllQuiz() {
      let allFinished = [];
      this.quizOnStatus.map((q) => {
        let numberOfQuestions = q.raw_data.questions.length;
        let numberOfAnswers = q.interacted ? q.interacted.filter((f) => f && f.length && f[0] !== null).length : 0;
        if (numberOfQuestions == numberOfAnswers) allFinished.push(true);
      });
      return allFinished.length >= this.quizOnStatus.length;
    },
    hasFinishedAllEssays() {
      let allFinished = [];
      this.essayOnStatus.map((q) => {
        let numberOfQuestions = q.raw_data.questions.length;
        let numberOfAnswers = q.interacted ? q.interacted.filter((f) => f && f.length && f[0] !== null).length : 0;
        if (numberOfQuestions == numberOfAnswers) allFinished.push(true);
      });
      return allFinished.length >= this.essayOnStatus.length;
    },
    hasFinishedAllPolls() {
      const numberOfPolls = this.pollOnStatus.length;
      let allFinished = [];
      this.pollOnStatus.map((q) => {
        if (q.interacted) allFinished.push(true);
      });
      return allFinished.length >= numberOfPolls;
    },
    hasFinishedAllWordclouds() {
      const numberOfWordclouds = this.wordcloudOnStatus.length;
      let allFinished = [];
      this.wordcloudOnStatus.map((q) => {
        if (q.interacted) allFinished.push(true);
      });
      return allFinished.length >= numberOfWordclouds;
    },
    hasFinishedEverything() {
      return this.hasFinishedAllQuiz && this.hasFinishedAllEssays && this.hasFinishedAllPolls && this.hasFinishedAllWordclouds;
    },
  },
  watch: {
    showQA(newVal) {
      if (newVal) this.pollQnA();
    },
    hasFinishedEverything(newVal) {
      if (newVal && this.activityData.property.nextRouteAutoRedirect && this.allLists.length > 0) {
        this.autoRedirectTimer = setTimeout(() => {
          this.submitAndContinue();
        }, 1000);
      }
    },
  },
  methods: {
    startTimer() {
      if (!this.enableIdleTimeout) return;
      this.timerId = setTimeout(() => {
        this.idleCounter++;
        // console.log('startTimer this.idleCounter', this.idleCounter);
        if (this.idleCounter >= this.idleTimeoutInSeconds) {
          this.clearTimer();
          this.$refs.header.logout();
        } else this.startTimer();
      }, 1000);
    },
    clearTimer() {
      if (!this.enableIdleTimeout) return;
      clearTimeout(this.timerId);
      if (this.idleCounter < this.idleTimeoutInSeconds) {
        this.idleCounter = 0;
        this.startTimer();
      }
    },
    loadActivity(isReload) {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;

          this.title = this.activityData.property.sectionTitle ? this.activityData.property.sectionTitle : '';

          //IDLE TIMEOUT
          this.enableIdleTimeout = this.activityData.property.enableIdleTimeout ? this.activityData.property.enableIdleTimeout : false;
          this.idleTimeoutInSeconds = this.activityData.property.idleTimeoutInSeconds ? this.activityData.property.idleTimeoutInSeconds : 90;
          if (this.enableIdleTimeout) this.startTimer();

          // ENDING PANEL PROPERTY
          this.showEndingPanel = this.activityData.property.showEndingPanel;
          this.panelEnterDelayInSeconds = this.activityData.property.panelEnterDelayInSeconds;

          if (!isReload) {
            if (!this.activityData.property.silenceWS) {
              this.connectWS();
              api
                .post('subscribeClient', {
                  //connectionId: Math.floor(Math.random() * 1111111111111111111),
                  data: {
                    channel: this.$route.params.stream,
                  },
                })
                .then((response) => {
                  if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    response.data.data.map((msg) => {
                      //console.log('Message = ', msg);
                      this.receiveMessage({ data: msg }, isReload);
                    });
                  }
                })
                .catch((err) => console.error('error subscribing', err));
            }
          }

          response.data.interactivity.forEach((item) => {
            this.activityData.interactivities[item.interactivity] = item.enable;
          });

          this.showChat = this.activityData.interactivities.chat;
          this.qnaConfig = this.activityData.property.interactivities.qa.config;
          // --qna-textColor
          this.$refs.interactionsSection.style.setProperty('--qna-textColor', this.qnaConfig.textColor);
          // qna-bgColor
          this.$refs.interactionsSection.style.setProperty('--qna-bgColor', this.qnaConfig.bgColor);
          // --qna-btnBgColor
          this.$refs.interactionsSection.style.setProperty('--qna-btnBgColor', this.qnaConfig.btnBgColor);
          // --qna-btnColor
          this.$refs.interactionsSection.style.setProperty('--qna-btnColor', this.qnaConfig.btnColor);
          // --qna-inputColor
          this.$refs.interactionsSection.style.setProperty('--qna-inputColor', this.qnaConfig.inputColor);
          // --qna-inputBgColor
          this.$refs.interactionsSection.style.setProperty('--qna-inputBgColor', this.qnaConfig.inputBgColor);

          this.getInteractivities(isReload);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getInteractivities(isReload) {
      api
        .get(`event/${this.$store.state.eventId}/channels/${this.$route.params.stream}/status`)
        .then((response) => {
          // console.log('getInteractivities /status Response: ', { response });
          this.interactionsOnStatus = response.data.sort((a, b) => a.order - b.order);
          const liveItem = this.interactionsOnStatus.find((i) => i.reference_type == 'live');
          if (liveItem && Array.isArray(liveItem.raw_data)) {
            const qnaLive = liveItem.raw_data.map((s) => JSON.parse(s)).find((o) => o.type === 'qna-live');
            if (qnaLive) {
              this.showQA = qnaLive.value;
              this.activityData.interactivities.qa = qnaLive.value;
            }
          }
          this.interactionsOnStatus = this.interactionsOnStatus.filter((i) => i.reference_type != 'live');
          this.interactionsOnStatus.map(async (interactivity) => {
            if (interactivity.reference_type == 'poll') {
              let poll = JSON.parse(interactivity.raw_data);
              if (!poll.language_code || poll.language_code == null || poll.language_code == this.$store.state.user.language) {
                this.activityData.interactivities.poll = true;

                if (poll.type.showResults) {
                  poll.answers = await this.getPollResults(poll.poll_id);
                  poll.interactions = poll.answers.reduce((acc, interactions) => acc + interactions, 0);
                  interactivity.raw_data.answers = poll.answers;
                }

                this.$nextTick((_) => {
                  if (this.$refs[interactivity.interactivity_id] && this.$refs[interactivity.interactivity_id][0] !== undefined) {
                    this.$refs[interactivity.interactivity_id][0].beginPoll(poll);
                    if (interactivity.interacted) {
                      // console.log('poll has interacted: ', { poll });
                      this.$refs[interactivity.interactivity_id][0].updatePoll(poll.answers, poll.interactions);
                    }
                    // let marker = `${this.$store.state.user.id}-${poll.poll_id}`;
                    if (!isReload && !interactivity.interacted) this.showPoll = true;
                    else if (isReload && this.showPoll) this.showPoll = true;
                    else {
                      this.showPoll = false;
                    }
                  }
                });
              }
            }
            if (interactivity.reference_type == 'quiz') {
              let quiz = JSON.parse(interactivity.raw_data);
              // console.log('quiz interactivity: ', { interactivity });
              if (!quiz.language_code || quiz.language_code == null || quiz.language_code == this.$store.state.user.language) {
                this.activityData.interactivities.quiz = true;

                this.$nextTick((_) => {
                  if (this.$refs[interactivity.interactivity_id] && this.$refs[interactivity.interactivity_id][0] !== undefined) {
                    this.$refs[interactivity.interactivity_id][0].beginQuiz(quiz);
                  }
                });
              }
            }
            if (interactivity.reference_type == 'answer' && !isReload) {
              let essay = JSON.parse(interactivity.raw_data);
              if (!essay.language_code || essay.language_code == null || essay.language_code == this.$store.state.user.language) {
                this.activityData.interactivities.answer = true;
                this.$nextTick((_) => {
                  if (this.$refs[interactivity.interactivity_id] && this.$refs[interactivity.interactivity_id][0] !== undefined) {
                    this.$refs[interactivity.interactivity_id][0].beginEssay(essay);
                  }
                });
              }
            }

            if (interactivity.reference_type == 'wordcloud') {
              let wordcloud = JSON.parse(interactivity.raw_data);
              // console.log('wordcloud', { interactivity });
              if (!wordcloud.language_code || wordcloud.language_code == null || wordcloud.language_code == this.$store.state.user.language) {
                this.activityData.interactivities.wordcloud = true;
                // console.log('wordcloud raw_data', interactivity.raw_data);
                try {
                  const data = JSON.parse(interactivity.raw_data);
                  this.checkWords({ id: data.wordcloud_id });
                } catch (error) {}
              }
            }
            if (interactivity.reference_type == 'links') {
              // console.log('links interactivity: ', { interactivity });
              let links = JSON.parse(interactivity.raw_data);
              if (!links.language_code || links.language_code == null || links.language_code == this.$store.state.user.language) {
                this.links.push(links);
              }
            }
            if (interactivity.reference_type == 'curtains') {
              let curtains = JSON.parse(interactivity.raw_data);
              if (!curtains.language_code || curtains.language_code == null || curtains.language_code == this.$store.state.user.language) {
                this.currentCurtain = curtains;
              }
            }
            if (interactivity.reference_type == 'banner_top') {
              // console.log('banner_top: ', { interactivity });
              this.stageBanner = JSON.parse(interactivity.raw_data);
              this.$nextTick(() => {
                this.resized();
              });
            }
            if (interactivity.reference_type == 'banner_video') {
              // console.log('banner_top: ', { interactivity });
              this.videoBanner = JSON.parse(interactivity.raw_data);
            }
          });
          this.$nextTick(() => {
            clearTimeout(this.autoRedirectTimer);
            if (this.hasFinishedEverything && this.activityData.property.nextRouteAutoRedirect && this.allLists.length > 0) {
              this.autoRedirectTimer = setTimeout(() => {
                this.submitAndContinue();
              }, 1000);
            }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    connectWS() {
      this.wsClient = new WebSocket('wss://websocket.blitzar.com.br');
      this.wsClient.addEventListener('message', this.receiveMessage);
      this.wsClient.addEventListener('open', () => {
        this.wsClient.send(
          JSON.stringify({
            type: 'subscribe',
            channel: this.$route.params.stream,
          }),
        );
      });
      this.wsClient.addEventListener('close', () => {
        this.wsClient.send(
          JSON.stringify({
            type: 'unsubscribe',
            channel: this.$route.params.stream,
          }),
        );
        this.wsClient = null;
        setTimeout(this.connectWS, 300000);
      });
      this.wsClient.addEventListener('error', () => {
        //console.log('ws error');
        this.wsClient.close();
      });
    },
    receiveMessage(incoming) {
      let msg = JSON.parse(incoming.data);
      // console.log('receiveMessage', msg);
      switch (msg.type) {
        case 'update-activity':
          try {
            let tempImages = { ...this.activityData.images };
            this.activityData = { ...this.activityData, ...msg.updateActivity };
            this.activityData.images = msg.updateActivity.images ? JSON.parse(msg.updateActivity.images) : tempImages;
            this.activityData.property = JSON.parse(this.activityData.property);
            msg.updateActivity.interactivity.forEach((item) => {
              this.activityData.interactivities[item.interactivity] = item.enable;
            });
            this.showChat = this.activityData.interactivities.chat;
          } catch (error) {
            console.error('error parsing activity property', error);
          }
          break;
        case 'subscribed':
          //console.log('subscribed');
          // api
          //   .post('subscribeClient', {
          //     connectionId: msg.connectionId,
          //     data: {
          //       channel: msg.channel,
          //     },
          //   })
          //   .then((response) => {
          //     console.log('subscribed');
          //   })
          //   .catch((err) => console.error('error subscribing', err));
          break;
        case 'begin-quiz':
          // console.log('beginQuiz', { msg });
          this.activityData.interactivities.quiz = true;
          // this.$refs[msg.quizQuestions.id][0].beginQuiz(msg.quizQuestions);
          this.getInteractivities();
          break;
        case 'end-quiz':
          this.getInteractivities();
          break;
        case 'begin-answer':
          this.activityData.interactivities.answer = true;
          // this.$refs[msg.quizQuestions.id][0].beginQuiz(msg.quizQuestions);
          this.getInteractivities();
          break;
        case 'end-answer':
          this.getInteractivities();
          break;
        case 'begin-poll':
          // this.$refs.poll.beginPoll(msg.poll);
          this.getInteractivities();
          break;
        case 'end-poll':
          this.getInteractivities();
          break;
        case 'update-interaction-poll':
          // console.log('update-interaction-poll !!!!', { msg });
          // this.$refs.poll.updatePoll(msg.answers, msg.totalVotes);
          if (this.$refs[msg.id]) this.$refs[msg.id][0]?.updatePoll(msg.answers, msg.totalVotes);
          this.interactionsOnStatus.map((interaction) => {
            if (interaction.interactivity_id == msg.id) {
              interaction.raw_data.answers = msg.answers;
            }
            return interaction;
          });
          break;
        case 'show-wordcloud-prompt':
          this.getInteractivities();
          break;
        case 'hide-wordcloud-prompt':
          this.getInteractivities();
          break;
        case 'update-interaction-wordcloud':
          // console.log('update-interaction-wordcloud', { msg });
          this.checkWords(msg);
          break;
        case 'qna-live':
          this.showQA = msg.value;
          if (this.showQA) {
            this.activityData.interactivities.qa = true;
          } else {
            this.activityData.interactivities.qa = false;
          }
          break;
      }
    },
    checkWords(msg) {
      // console.log('checkWords', { msg });
      api
        .get(`activity/${this.$route.params.stream}/wordcloud/${msg.id}/result`)
        .then((response) => {
          // console.log('checkWords response', { response });
          this.interactionsOnStatus = this.interactionsOnStatus.map((inter) => {
            if (inter.interactivity_id == msg.id) {
              inter.interactions = response.data;
            }
            return inter;
          });
          this.$nextTick(() => {
            try {
              if (this.$refs[msg.id]) this.$refs[msg.id][0].viewWordcloud(msg.id);
            } catch (error) {}
          });
        })
        .catch((err) => {
          console.error(err);
        });
      // api
      //   .get(`activity/${this.$route.params.activityId}/wordcloud/${wordcloud.wordcloud_id}/forbidden`)
      //   .then((response) => {
      //     console.log('forbidden ', response.data);
      //     wordcloud.forbidden = response.data;
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
    },
    pollQnA() {
      if (!this.activityData || !this.activityData.interactivities || !this.activityData.interactivities.qa) return;
      const sidebox = this.$refs.sidebox;
      try {
        if (sidebox && sidebox.$refs && sidebox.$refs.qnaBox && typeof sidebox.$refs.qnaBox.apiGetQnAQuestions === 'function') {
          sidebox.$refs.qnaBox.apiGetQnAQuestions();
        }
      } catch (err) {
        console.error('pollQnA error', err);
      }
    },
    finishQuiz(obj) {
      // console.log('finish External Quiz', { obj });
      api
        .post('/answerQuiz', {
          userId: this.$store.state.user.id,
          quiz_id: obj.id,
          answers: obj.answers,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log("setScore after finish External Quiz", response.data);

          // return;
          if (this.$refs[obj.id] && this.$refs[obj.id][0]) {
            this.$refs[obj.id][0].setScore(response.data.score);
          }
          let marker = `${this.$store.state.user.id}-${obj.id}`;
          this.$store.commit('setMarker', { target: 'answeredQuiz', marker: marker });
          this.getInteractivities();

          if (response.data.score >= 1) {
            api.post(`sessionAction/`, {
              action: 'Quiz Answer Right',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, quiz_id: obj.id }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          } else {
            api.post(`sessionAction/`, {
              action: 'Quiz Answer Wrong',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, quiz_id: obj.id }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          }
        });
    },
    finishEssay(obj) {
      api
        .post('/answerAnswer', {
          userId: this.$store.state.user.id,
          answer_id: obj.id,
          answers: obj.answers,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log('finishEssay', { response });
          // return;
          if (this.$refs[obj.id] && this.$refs[obj.id][0]) {
            this.$refs[obj.id][0].setScore(response.data.score);
          }
          let marker = `${this.$store.state.user.id}-${obj.id}`;
          this.$store.commit('setMarker', { target: 'answeredEssay', marker: marker });
          this.getInteractivities();

          if (response.data.score >= 1) {
            api.post(`sessionAction/`, {
              action: 'Essay Answer Right',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          } else {
            api.post(`sessionAction/`, {
              action: 'Essay Answer Wrong',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          }
        });
    },
    finishPoll(answer) {
      api
        .post(`/answerPoll/${this.$route.params.stream}`, {
          userId: this.$store.state.user.id,
          poll_id: answer.id,
          answer: answer.answer,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log('finishPoll', { response });
          let marker = `${this.$store.state.user.id}-${answer.id}`;
          this.$store.commit('setMarker', { target: 'answeredPolls', marker: marker });
          api.post(`sessionAction/`, {
            action: 'Poll Answer',
            properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, poll_id: answer.id }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
          this.getInteractivities();
        });
    },
    getPollResults(id) {
      return new Promise((resolve, reject) => {
        api
          .get(`/event/${this.$store.state.eventId}/poll/${id}/result`)
          .then((response) => {
            // console.log('getPollResults', { response });
            resolve(response.data.answers);
          })
          .catch((error) => {
            console.error('getPollResults error', error);
            reject(error);
          });
      });
    },
    checkSendQuestion(key) {
      if (key.keyCode == 13) this.sendGeneralQuestion();
    },
    updateUserName() {
      api
        .put(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`, { name: this.concatedUserName() })
        .then((response) => {
          this.$store.commit('setUserName', this.concatedUserName());
          // console.log('updateUserName', { response });
        })
        .catch((err) => {
          console.error('error updating user name', err);
        });
    },
    sendGeneralQuestion() {
      clearTimeout(this.sendQuestionTimeout);
      this.sendQuestionTimeout = setTimeout(() => {
        if (this.question.length > 0 && this.question.length <= this.qnaConfig.maximumNumberOfCharacters) {
          let msg = {
            type: 'send-question',
            channel: this.$route.params.stream,
            userId: this.$store.state.user.id,
            userName: this.concatedUserName(),
            text: this.question,
            theme: this.activityData.property.interactivities.qa.config.useThemes && this.activityData.property.interactivities.qa.config.currentTheme ? this.activityData.property.interactivities.qa.config.currentTheme : null,
            properties: null,
          };
          api
            .post(`send-question/${this.$route.params.stream}`, msg)
            .then((response) => {
              this.question = '';
              this.$notify.success({
                title: 'Mensagem enviada com sucesso!',
                message: 'Obrigado pela sua participação!',
                position: 'bottom-right',
                offset: 120,
                customClass: 'elementsui-notify-success',
              });
              api.post(`sessionAction/`, {
                action: 'Question Send',
                properties: JSON.stringify(msg),
                userid: this.$store.state.user.id,
                sessionid: this.$store.state.user.token,
                event_id: this.$store.state.eventId,
              });
            })
            .catch((err) => {
              console.error('error sending question', err);
            });
        } else if (this.question.length > this.qnaConfig.maximumNumberOfCharacters) {
          alert(`A mensagem não pode ter mais de ${this.qnaConfig.maximumNumberOfCharacters} caracteres.`);
        }
      }, 300); // 300ms debounce time
    },
    concatedUserName() {
      return `${this.userName} - ${this.userCity}`;
    },
    handleEndingPanelClick() {
      const destinationRoute = this.activityData.property.nextRoute;
      if (!destinationRoute) {
        this.$refs.header.logout();
      } else if (typeof destinationRoute === 'string' && destinationRoute.startsWith('http')) {
        window.location.href = destinationRoute;
      } else {
        this.$router.push(destinationRoute);
      }
    },
    submitAndContinue() {
      if (!this.hasFinishedEverything && !this.activityData.property.nextRouteBtnEnableAllways) return;
      api.post(`sessionAction/`, {
        action: 'FinishInteraction',
        properties: JSON.stringify({
          channel: this.$route.params.stream,
        }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
      const destinationRoute = this.activityData.property.nextRoute ? this.activityData.property.nextRoute : { name: 'Home' };
      if (typeof destinationRoute === 'string' && destinationRoute.startsWith('http')) {
        window.location.href = destinationRoute;
      } else {
        this.$router.push(destinationRoute).catch(() => {});
      }
    },
  },
  beforeMount() {
    if (this.$store.state.user.name && this.$store.state.user.name.includes(' - ')) {
      this.userName = this.$store.state.user.name.split(' - ')[0];
      this.userCity = this.$store.state.user.name.split(' - ')[1];
    }

    if (window.innerWidth <= 1080) this.isMobile = true;
    else this.isMobile = false;
    this.loadActivity();
  },
  mounted() {
    document.addEventListener('click', this.clearTimer);
    document.addEventListener('keydown', this.clearTimer);
    document.addEventListener('mousemove', this.clearTimer);
    document.addEventListener('scroll', this.clearTimer);

    this.loadingInterval = setInterval(() => {
      this.loadActivity(true);
    }, 120000);

    // Start QnA polling every 60 seconds
    this.qnaPollingInterval = setInterval(() => {
      this.pollQnA();
    }, 60000);
    if (this.showQA) this.pollQnA();
  },
  beforeDestroy() {
    clearTimeout(this.timerId);
    document.removeEventListener('click', this.clearTimer);
    document.removeEventListener('keydown', this.clearTimer);
    document.removeEventListener('mousemove', this.clearTimer);
    document.removeEventListener('scroll', this.clearTimer);
    clearInterval(this.loadingInterval);
    clearInterval(this.qnaPollingInterval);
    clearTimeout(this.autoRedirectTimer);
    if (this.wsClient) {
      this.wsClient.send(
        JSON.stringify({
          type: 'unsubscribe',
          channel: this.$route.params.stream,
        }),
      );
    }
  },
};
</script>

<style lang="scss">
.external-interactions-section {
  position: absolute;
  inset: 0 0 auto 0;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  padding-top: 60px;
  width: 100%;
  min-height: 100dvh;
  user-select: none;

  @include media('<=phone-plus') {
    padding-top: 38px;
  }

  @include media('<=phone') {
    padding-top: 50px;
  }

  .interactions-title {
    position: relative;
    width: 100%;
    margin-top: 1.5%;
    font-size: 3rem;
    display: flex;
    justify-content: center;
  }

  .page-container {
    position: relative;
    background-color: transparent;
    flex-grow: 1;
    height: calc(100dvh - 110px);
    padding: 0 3% 40px 3%;
    margin-top: 10px;
    overflow-x: hidden;
    z-index: 0;
    overflow-y: auto;

    display: flex;
    flex-direction: row;
    align-items: stretch;
    align-content: stretch;
    justify-content: center;
    gap: 10px;

    @include media('<=tablet') {
      flex-wrap: wrap;
      margin-top: 30px;
    }

    @include media('<=phone') {
      margin-top: 0px;
      height: calc(100dvh - 80px);
    }

    .interactions-container {
      position: relative;
      flex-grow: 1;
      max-width: 580px;
      // max-height: calc(100dvh - 140px);
      // overflow-y: auto;

      display: flex;
      flex-direction: column;
      gap: 10px;

      &::-webkit-scrollbar {
        background-color: transparent;
        width: 8px;
      }

      @include media('<=tablet') {
        // max-width: 80%;
      }
      @include media('<=phone-plus') {
        max-width: 100%;
      }
    }

    .interactions-qna-container {
      position: relative;
      flex-grow: 1;
      max-width: 580px;

      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        background-color: transparent;
        width: 8px;
      }

      @include media('<=tablet') {
        // max-width: 80%;
      }
      @include media('<=phone-plus') {
        max-width: 100%;
      }

      .interactions-qna-header {
        position: relative;
        width: 100%;
        padding: 1.6% 8%;
        z-index: 10;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 1px;
        border: none;
        border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
        outline: none;
        background: var(--qna-bgColor);
        backdrop-filter: blur(40px);
      }

      .interactions-qna-box-title {
        position: relative;
        color: var(--qna-textColor);
        font-size: 1rem;
        text-align: center;
        font-weight: bold;
      }

      input,
      textarea {
        padding: 10px;
        font-size: 1rem;
        border: none;
        color: var(--qna-inputColor);
        background: var(--qna-inputBgColor) !important;
      }

      input::placeholder,
      textarea::placeholder {
        color: var(--qna-inputColor);
        opacity: 0.5;
      }

      textarea {
        resize: none;
      }

      button {
        border: none;
        padding: 10px;
        color: var(--qna-btnColor);
        background: var(--qna-btnBgColor);
        border-radius: 0 0 var(--input-borderRadius) var(--input-borderRadius);
      }
    }
  }
}
.interactions-hero {
  position: relative;
  width: 100%;
  min-height: 200px;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  .interactions-hero-image {
    max-width: 100%;
    height: 100%;
    max-height: 400px;
    object-fit: cover;
    object-position: center;
  }
}
.interaction-ending-panel {
  position: fixed;
  inset: 0;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  z-index: 1;

  .image-container {
    position: relative;
    width: 100vw;
    height: 100dvh;
    margin-top: 99px;

    display: flex;
    align-items: flex-start;
    justify-content: center;

    img {
      position: absolute;
      inset: auto;
      width: 100%;
      max-height: 70dvh;
      object-fit: contain;
      object-position: center;
    }
  }
}
.interactions-submit-container {
  position: relative;
  padding: 10px 0;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  .interactions-submit-button {
    position: relative;
    width: 100%;
    max-width: 400px;
    height: 40px;
    padding: 0 20px;
    border: none;
    border-radius: var(--input-borderRadius);
    background-color: var(--button-background);
    color: var(--button-text);
    font-size: 1rem;
    font-weight: bold;
    letter-spacing: 1px;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

.interactions-all-finished-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  backdrop-filter: grayscale(0.5) opacity(0.8);

  display: flex;
  align-items: center;
  justify-content: center;
}

.interactions-all-finished-modal-content {
  position: relative;
  min-width: 340px;
  min-height: 200px;
  padding: 20px;
  border-radius: var(--input-borderRadius);
  background-color: var(--main-color);
  color: var(--main-text);
  text-align: center;
  line-height: 1.5;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  img {
    filter: invert(1) brightness(1.5);
  }
}

// TRANSITIONS
.delayed-opacity-enter-active,
.delayed-opacity-leave-active {
  transition: all var(--delayedOpacity-panelEnterDelayInSeconds) ease-in;
  opacity: 0;
  pointer-events: none;
}
.elementsui-notify-success {
  background-color: var(--main-color);
  color: var(--main-color);
  border: 1px solid var(--main-color);
  font-family: 'Roboto', sans-serif;
}

.poster {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 60%;
  transform: translate(-50%, -50%);
  z-index: 0;
  object-fit: contain;
  @media (max-width: 768px) {
    top: 40%; /* Move um pouco para cima no mobile */
  }
}
</style>
